import { useQuery } from '@tanstack/react-query'
import { observer } from 'mobx-react'
import { useContext, useEffect } from 'react'

import { Layout } from '@/components/Layout'
import { getUser } from '@/services/user.service'
import { UserStoreContext } from '@/stores/UserStore'

import {
  EmailAddressesSection,
  PersonalInformationSection,
  PasswordSection,
  PhoneNumberSection,
  SecurityNotificationsSection,
} from './Sections'

/**
 *
 * UserProfile
 *
 */
const UserProfile = observer(() => {
  // Context
  const { setUser, user } = useContext(UserStoreContext)

  const { data: freshUser } = useQuery({
    queryKey: ['users', user.id],
    queryFn: () => getUser(user.id),
    enabled: !!user?.id,
  })

  useEffect(() => {
    if (freshUser) {
      setUser(freshUser)
    }
  }, [freshUser, setUser])

  return (
    <Layout breadcrumbs={['Account Settings']}>
      <Layout.Heading title="Account Settings" />

      <div className="divide-accent mt-5 items-center space-y-8 divide-y">
        <PersonalInformationSection />
        <EmailAddressesSection />
        <PasswordSection />
        <PhoneNumberSection />
        <SecurityNotificationsSection />
      </div>
    </Layout>
  )
})

export default UserProfile
